import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@machobear/design-system'
import { Profile as FullProfile } from '@/types'
import useProfile from '@/hooks/use-profile'
import { usePersonaIdVerification } from './id-verification'

type Profile =
  | Pick<FullProfile, 'id' | 'first_name' | 'last_name' | 'identity_verified_state'>
  | undefined

interface VerificationProps {
  onComplete?: () => void
  onExit?: () => void
  disabled?: boolean
}

export const IdVerificationButton = ({
  onComplete,
  onExit,
  disabled
}: Omit<VerificationProps, 'profile' | 'language'>) => {
  const { t } = useTranslation()
  const profile = useProfile() as Profile
  const personaIdVerification = usePersonaIdVerification()
  const identityVerified = profile?.identity_verified_state

  const currentButtonText = useMemo(() => {
    switch (identityVerified) {
      case 'verified':
        return t('common.verified', 'Verified')
      case 'pending':
        return t('l.listing.verify.id_verified_state.pending', 'Verifying...')
      default:
        return t('l.listing.verify.id_verified_state.unverified', 'Verify Now')
    }
  }, [identityVerified, t])

  return (
    <Button
      disabled={disabled || identityVerified === 'verified' || identityVerified === 'pending'}
      variant="solid"
      size="standard"
      onClick={() => personaIdVerification({ onComplete, onExit })}
    >
      {currentButtonText}
    </Button>
  )
}
